import React from 'react'
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom'

import Create from './pages/create'
import List from './pages/list'

/**
 *
 */
const NumberAssignement = (): JSX.Element => {
    const { pathname } = useLocation()
    const history = useHistory()

    const appPath = '/number-assignement'
    const basePath = `${pathname.split(appPath)[0]}${appPath}`

    const goToCreatePage = () => {
        history.push(`${basePath}/create`)
    }

    return <div>
        <Switch>
            <Route
                path={`${basePath}/create`}
                render={() => (
                    <Create />
                )}
            />
            <Route
                path={basePath}
                render={() => (
                    <List
                        onClickAddNew={goToCreatePage}
                    />
                )}
            />
            <Route
                path='/'
                render={() => <Redirect to={`${basePath}`} />}
            />
        </Switch>
    </div>
}

export default NumberAssignement
